function initStorePageSwipers() {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.store-card-swiper').forEach((element) => {
    if (element.dataset.storeSwiperInitialized === 'true') return;

    const pagination = element.querySelector('.store-card__pagination');

    new Swiper(element, {
      slidesPerView: 1,
      speed: 700,
      loop: true,
      allowTouchMove: true,
      pagination: {
        el: pagination,
        clickable: true
      }
    });

    element.dataset.storeSwiperInitialized = 'true';
  });
}

const STORE_SWIPER_RETRY_DELAY = 100;
const STORE_SWIPER_MAX_RETRIES = 50;

function waitForStoreSwiper(attempt = 0) {
  if (typeof Swiper !== 'undefined') {
    initStorePageSwipers();
    return;
  }

  if (attempt >= STORE_SWIPER_MAX_RETRIES) return;

  window.setTimeout(() => {
    waitForStoreSwiper(attempt + 1);
  }, STORE_SWIPER_RETRY_DELAY);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', waitForStoreSwiper);
} else {
  waitForStoreSwiper();
}
